import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isSignature(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.SIGNATURE && typeof label === 'string' && Array.isArray(value);
}
function _formatSignature(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value: true
  };
}
export function formatSignature(submission) {
  if (isSignature(submission)) {
    return _formatSignature(submission);
  }
  return undefined;
}
//# sourceMappingURL=signature-preview.js.map